"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SecureText/TextKindLabel.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _secureText = require('shared/constants/secureText');

 const LOCK_ICON_SRC = '/assets/icons/secure-text/lock.svg'; exports.LOCK_ICON_SRC = LOCK_ICON_SRC
 const UNLOCK_ICON_SRC = '/assets/icons/secure-text/unlock.svg'; exports.UNLOCK_ICON_SRC = UNLOCK_ICON_SRC






// A lock (secure text with link) or open lock (insecure text) before the label.
const TextKindLabel = ({ isSecure, label }) => (
  _react2.default.createElement('span', { className: "secure-text--kind-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}
    , _react2.default.createElement('img', {
      className: "secure-text--kind-label--icon",
      src: isSecure ? exports.LOCK_ICON_SRC : exports.UNLOCK_ICON_SRC,
      alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
    )
    ,  _nullishCoalesce(label, () => ( (isSecure ? _secureText.SECURE_TEXT_LABEL : _secureText.INSECURE_TEXT_LABEL))) 
  )
)

exports. default = TextKindLabel
